import React, { FC } from "react";
import { motion } from "framer-motion";

const PageTransition: FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div
    // initial={{ opacity: 0, y: 20 }}
    // animate={{ opacity: 1, y: 0 }}
    // exit={{ opacity: 0, y: -20 }}
    // transition={{ duration: 0.3 }}
    initial={{ opacity: 0, x: -20 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: 20 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

export default PageTransition;
